export default __webpack_public_path__ + "8a78a2d48d07f7ddca287bcb5b9da8e7.svg";